import { ReactElement } from 'react'
import { BackButton, Loader, PageWrapper } from '../../../../components'
import { useHistory } from 'react-router-dom'
import { CardWrapper } from '../subcomponents'
import { FlexWrapper, Column } from '../../../../components'
import strings from '../../../../locale/en'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { RootState } from '../../../../redux/store'
import { Institute } from '../../../../redux/coachingCenter/types'
import { resetBranch } from '../../../../redux/coachingCenter/actions'
import { DATE_FORMAT_MMDDYYYY } from '../../../../const/dateFormat'
import format from 'date-fns/format'

const InstituteDetail = (): ReactElement => {
  const { isLoading, institute, additionalCourses } = useSelector(
    (state: RootState) => ({
      isLoading: state.coachingCenter.isLoading,
      institute: state.coachingCenter.selectedInstitute as Institute,
      additionalCourses: state.coachingCenter.additionalCourses
    }),
    shallowEqual
  )

  const dispatch = useDispatch()
  const history = useHistory()
  const {
    instituteDetails: {
      instituteNameLabel,
      mobileNumberLabel,
      emailLabel,
      expiresOnLabel,
      statusLabel,
      address1Label,
      address2Label,
      countryLabel,
      stateLabel,
      cityLabel,
      zipcodeLabel,
      upmyranksCoursesLabel
    }
  } = strings

  const {
    coachingCentreName,
    mobileNumber,
    email,
    address1,
    address2,
    country,
    state,
    city,
    zipCode,
    expiryOn,
    status
  } = institute || {}

  return isLoading ? (
    <Loader />
  ) : (
    <PageWrapper id="container">
      <div>
        <BackButton
          handleBack={() => {
            dispatch(resetBranch())
            history.goBack()
          }}
        />
      </div>
      <FlexWrapper justifyContent="space-around">
        <CardWrapper>
          <Column keyName={instituteNameLabel} value={coachingCentreName} />
          <Column keyName={address1Label} value={address1} />
          <Column keyName={address2Label} value={address2} />
          <Column keyName={countryLabel} value={country} />
          <Column keyName={stateLabel} value={state} />
          <Column keyName={cityLabel} value={city} />
          <Column keyName={zipcodeLabel} value={zipCode} />
        </CardWrapper>
        <CardWrapper>
          <Column keyName={mobileNumberLabel} value={mobileNumber} />
          <Column keyName={emailLabel} value={email} />
          <Column keyName={expiresOnLabel} value={expiryOn} />
          <Column keyName={statusLabel} value={status} />
          <Column keyName={upmyranksCoursesLabel}>
            {additionalCourses.map(({ course, expiryDate }, index) => (
              <div key={`additionalCourse-${index}`}>
                {course?.courseName}---
                {format(new Date(expiryDate), DATE_FORMAT_MMDDYYYY)}
              </div>
            ))}
          </Column>
        </CardWrapper>
      </FlexWrapper>
    </PageWrapper>
  )
}

export default InstituteDetail
